'use client';

import dynamic from 'next/dynamic';

const TradingViewEmbed = dynamic(() => import('@/components/charts/TradingViewEmbed'), {
  ssr: false,
});

export default function TradingChart({ className }: { className?: string }) {
  return <TradingViewEmbed className={className} />;
}
